export default __webpack_public_path__ + "static/media/mode-icon.d1769e38.svg";